import React from "react";

function HowItWorks() {
  return (
    <div className="bg-[#222831] py-20 px-6 text-center">
      <h1 className="text-4xl font-bold text-white mb-6">⚡ How It Works</h1>
      <p className="text-gray-300 mb-12 max-w-2xl mx-auto">
        Get started in just three simple steps and accelerate your coding journey.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Step 1 */}
        <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
          <h2 className="text-2xl font-semibold text-white">🚀 Step 1</h2>
          <p className="text-gray-300 mt-2">Sign up and set your coding goals.</p>
        </div>
        {/* Step 2 */}
        <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
          <h2 className="text-2xl font-semibold text-white">📈 Step 2</h2>
          <p className="text-gray-300 mt-2">Practice daily and track your progress.</p>
        </div>
        {/* Step 3 */}
        <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
          <h2 className="text-2xl font-semibold text-white">🏆 Step 3</h2>
          <p className="text-gray-300 mt-2">Join contests and compete with peers.</p>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
